var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-installer" }, [
    _c(
      "div",
      { staticClass: "sports-page" },
      [
        _c(
          "v-layout",
          { staticClass: "page-layout" },
          [
            _c(
              "v-flex",
              {
                ref: "maincolumn",
                staticClass: "main-column",
                style: { paddingTop: _vm.headerHeight + "px" }
              },
              [
                _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
                _vm._v(" "),
                _c("div", { staticClass: "staticcontent" }, [
                  _c(
                    "div",
                    { staticClass: "static-content accpage" },
                    [
                      _vm.routeName === "app"
                        ? _c("static-content", {
                            attrs: {
                              staticcontentpath:
                                "/static/appinstaller/" +
                                _vm.$i18n.locale +
                                "/app.html",
                              fullPath: true,
                              method: "html"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.routeName === "android"
                        ? _c("static-content", {
                            attrs: {
                              staticcontentpath:
                                "/static/appinstaller/" +
                                _vm.$i18n.locale +
                                "/android.html",
                              fullPath: true,
                              method: "html"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-131234cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-131234cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppInstaller.vue
// module id = null
// module chunks = 